import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var FishingIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    d: "M16 12a1 1 0 0 1 .993.883L17 13v11.5a7.5 7.5 0 0 1-14.996.243L2 24.5V20c0-.76.807-1.229 1.458-.89l.097.058 3 2a1 1 0 0 1-1.009 1.723l-.1-.059L4 21.868V24.5a5.5 5.5 0 0 0 5.279 5.496L9.5 30a5.5 5.5 0 0 0 5.496-5.279L15 24.5V13a1 1 0 0 1 1-1z"
  }), React.createElement("path", {
    d: "M28.445 19.168a1.002 1.002 0 0 1 1.55.72L30 20v4.5a7.5 7.5 0 0 1-15 0 1 1 0 0 1 2 0 5.5 5.5 0 0 0 10.996.221L28 24.5v-2.632l-1.445.964a1 1 0 0 1-1.317-.184l-.07-.093a1 1 0 0 1 .184-1.317l.093-.07 3-2zM16 0a5 5 0 1 0 .001 10.001A5 5 0 0 0 16 0zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
  }));
});

export default FishingIcon;
//# sourceMappingURL=fishing.svg.js.map
